import _slicedToArray from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from "react";
import { calculateFocusTarget } from "./helpers/calculateFocusTarget.js";
import { getNextFocus } from "./helpers/getNextFocus.js";
/** @private */
export function useFocus(props, calendar, getModifiers, isSelected, dateLib) {
  var autoFocus = props.autoFocus;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    lastFocused = _useState2[0],
    setLastFocused = _useState2[1];
  var focusTarget = calculateFocusTarget(calendar.days, getModifiers, isSelected || function () {
    return false;
  }, lastFocused);
  var _useState3 = useState(autoFocus ? focusTarget : undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    focusedDay = _useState4[0],
    setFocused = _useState4[1];
  var blur = function blur() {
    setLastFocused(focusedDay);
    setFocused(undefined);
  };
  var moveFocus = function moveFocus(moveBy, moveDir) {
    if (!focusedDay) return;
    var nextFocus = getNextFocus(moveBy, moveDir, focusedDay, calendar.navStart, calendar.navEnd, props, dateLib);
    if (!nextFocus) return;
    calendar.goToDay(nextFocus);
    setFocused(nextFocus);
  };
  var isFocusTarget = function isFocusTarget(day) {
    return Boolean(focusTarget === null || focusTarget === void 0 ? void 0 : focusTarget.isEqualTo(day));
  };
  var useFocus = {
    isFocusTarget: isFocusTarget,
    setFocused: setFocused,
    focused: focusedDay,
    blur: blur,
    moveFocus: moveFocus
  };
  return useFocus;
}